<template>
    <MainPage pageTitle="สิทธิพิเศษ" bgClass="bg-a-gray-efefef" menuBar>
        <div class="pt-5 px-3" >

            <HistoryList
                ref="history-list"
                :listConfig="purchaseListConfig"
                :filterConfig="purchaseFilterListConfig"
            ></HistoryList>
            
        </div>

    </MainPage>
</template>
<script>
import ConfigManager from '@/config/ConfigManager.js';
import Util from '@/helper/Utility.js';
//component
import MainPage from '@/components/Layout/Page/MainPage.vue';
import HistoryList from '../component/HistoryRedeem/HistoryList.vue';
//mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
//service
import {
    PurchaseListConfigBuilder,
    PurchaseFilterConfigBuilder,
} from '@/core/History/config/HistoryConfigModel.js';

export default {
    name: 'History',
    mixins: [ModalMixin, AuthStatusMixin],
    components: {
        MainPage,
        HistoryList,
    },
    data: function() {
        return {
            purchaseListConfig: null,
            purchaseFilterListConfig: null,

            historyTabActive: '',
        };
    },
    computed: {
        isHistoryRedeem: function() {
            return this.historyTabActive == 'redeem' || this.historyTabActive == '';
        },
        isHistoryPoint: function() {
            return !this.isHistoryRedeem;
        },
    },
    created: function () {
        this.initialIsFromLanding();
        this.historyTabActive = this.$route.params.tab;
        this.setScrollLoadMore();
        this.setupHistoryList();
    },
    mounted: async function() {
        this.modal.loadingModal.show();
        if (this.isHistoryRedeem) {
            await this.$refs['history-list'].getList();
        }
        this.modal.loadingModal.hide();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        /**
         * Function หลังจากหลับมาจากเว็บ Interface ให้ clear browser history
         */
        initialIsFromLanding: function () {
            let backCount = this.$route.query.back;
            if (Util.isNumber(backCount) && backCount != 0) {
                this.$router.go(backCount);
            }
        },

        //#region mixin
        onSetupModalCompleted: function() {
            this.initialHistoryModal();
        },
        //#endregion mixin
        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                let scrollOffSet = 100;
                let pageHeight = Math.max(
                    window.scrollY,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                let bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        setupHistoryList: async function () {
            //initial config for api.

            let listConfig = new PurchaseListConfigBuilder()
                .setConfigList(ConfigManager.getHistoryPurchaseList())
                .setTop(25)
                .create();
            this.purchaseListConfig = listConfig;

            //initial filter config for api.
            let filterListConfig = new PurchaseFilterConfigBuilder()
                .create();
            this.purchaseFilterListConfig = filterListConfig;
        },

        loadMore: async function() {
            this.modal.loadingModal.show();
            if (this.isHistoryRedeem) {
                await this.$refs['history-list'].loadMore();
            }
            this.modal.loadingModal.hide();
        },
    },
}
</script>
